/**
 * Custom functionality for Home page.
 */

/* global jQuery */

// const beforeAfter = require('../components/before-after');

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const ourApproach = require('../components/our-approach-block');
const benefits = require('../components/benefits-block-st');
const featuredProducts = require('../components/featured-products');
const testimonials = require('../components/testimonials-block');
const press = require('../components/press-block');

function initIRLSlider() {
    // Set up slider for IRL images in mobile.
    // Will this work with Instagram?
    let 
        $mySlider = $('#sbi_images'),
        options = {
            centerMode:false,
            cssEase:'ease-out',
            infinite:true,
            mobileFirst:true,
            slidesToShow:2,
            // slidesToScroll:2,
            swipe:true,
            swipeToSlide:true,
            arrows:true,
            adaptiveHeight:true,
            prevArrow: $('.irl__arrow.prev'),
            nextArrow: $('.irl__arrow.next'),
            responsive: [
                {
                    breakpoint:510,
                    // breakpoint:480,
                    settings: {
                        slidesToShow:2,
                        // slidesToScroll:2,
                    }
                },
                {
                    breakpoint:768,
                    // breakpoint:800,
                    settings: {
                        slidesToShow:3,
                        // slidesToScroll:3,
                    }
                },
                {
                    breakpoint:1024,
                    // breakpoint:800,
                    settings: {
                        arrows:false,
                        slidesToShow:4,
                        // slidesToScroll:4,
                    }
                }
            ]
        };


    // $mySlider.on('init', function(event, slick) {   // This callback is fired too soon. Sticking with timer.
    //     console.log("slick initialized");
    //     restoreSlickSlideImages();
    // })

    $mySlider.slick(options);
}

function restoreSlickSlideImages() {
    console.log('restoreSlickSlideImages()');
    let 
        $dupes = $('.sbi_num_diff_hide');

    $dupes.each(function(i) {
        var $postAnchor = $(this).find('a.sbi_photo');
        var $postImg = $(this).find('img');
        var image_url = $postAnchor.data('full-res');
        image_url = image_url.replace("full", "low");
        $postAnchor.css('background-image', 'url('+image_url+')');
        $(this).removeClass('sbi_num_diff_hide');
        $postImg.attr('src', image_url);
    });
}

exports.init = function() {
    // Home page initialization.  $ is available here...
    initIRLSlider();
    // restoreSlickSlideImages();
    setTimeout(restoreSlickSlideImages, 1000);
    initModule(ourApproach);
    initModule(benefits);
    initModule(featuredProducts);
    initModule(testimonials);
    initModule(press);
};

function initModule(mod) {
	console.log("initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}